<template>
  <v-container fluid>
    <v-row class=" p-y-6 mb-5">
      <v-col lg="3" sm="12">
        <BackButton :handler="gotoSalesTeam"/>
      </v-col>
      <v-col lg="6" md="6" sm="12">

        <div class="d-flex justify-center align-center gap-x-6">
          <div style="max-width: 16rem;max-height: 10rem">
            <view-image :image="salesTeamInfo.profile_image ? salesTeamInfo.profile_image : ''" width="165px"
                        :height="165" class="rounded-lg" defaultImage="user"/>
          </div>
          <div class="mt-2">
            <h3 class="text-xl m-b-4">
              {{ salesTeamInfo.first_name }} {{ salesTeamInfo.last_name || "" }}
            </h3>
            <div class="d-block d-lg-flex gap-x-8">
              <SvgIcon class="gap-x-4 m-b-4 font-medium">
                <template v-slot:icon>
                  <SMSIcon/>
                </template>
                {{ salesTeamInfo.email }}
              </SvgIcon>
              <SvgIcon class="gap-x-4 m-b-4 font-medium">
                <template v-slot:icon>
                  <CallIcon/>
                </template>
                {{ salesTeamInfo.mobile }}
              </SvgIcon>
            </div>
            <div class="d-flex gap-x-8 ">
              <div class="stats_data">
                <p class="text-dark-gray text-base font-normal">Deals</p>
                <p class="text-blue font-semibold">
                  {{ salesTeamInfo.total_deals ? Number(salesTeamInfo.total_deals) : 0 | numberFormatter }}</p>
              </div>
              <div class="stats_data">
                <p class="text-dark-gray text-base font-normal">Sales</p>
                <p class="text-blue font-semibold">
                  {{ salesTeamInfo.total_sales ? Number(salesTeamInfo.total_sales) : 0 | toCurrency }}</p>
              </div>
              <div class="stats_data">
                <p class="text-dark-gray text-base font-normal">Revenue</p>
                <p class="text-blue font-semibold">
                  {{ salesTeamInfo.total_revenue ? Number(salesTeamInfo.total_revenue) : 0 | toCurrency }}</p>
              </div>
              <div class="stats_data">
                <p class="text-dark-gray text-base font-normal">Commission</p>
                <p class="text-blue font-semibold">
                  {{ salesTeamInfo.total_commission ? Number(salesTeamInfo.total_commission) : 0 | toCurrency }}</p>
              </div>
            </div>
          </div>
        </div>

      </v-col>
      <v-col lg="3" sm="12" class="mt-sm-3  d-sm-flex">
        <div class="d-flex gap-x-4 ">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  style="background-color: rgba(17, 42, 70, 0.1) ; color:#112A46; min-width: 36px !important; "
                  class=" text_capitalize "
                  outlined
                  v-bind="attrs"
                  v-on="on"

              >
                <EditBtnIcon/>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="editSalesTeam">
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <v-list-item @click="confirmDelete(salesTeamInfo)">
                <v-list-item-title>{{ salesTeamInfo.status_id == 1 ? 'Deactivate' : 'Reactivate' }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn class="white--text blue-color" color=" darken-1" text @click="addDeal">
            <AddIcon/>
            <span class="ml-1">Add Deal</span>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <div class="row mt-4">
      <div class="col-12">
        <v-card class="shadow-0">
          <v-card-text>
            <v-row no-gutters class="mt-6">
              <SalesTeamDeals
                  :refreshData="refreshData"
                  :salesTeamId="salesTeamId"
                  :salesTeam="salesTeamInfo"
                  @openDealModal="addDeal"
              />
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <SalesTeamPopup :editDialog="addSalesTeamDialog" :user-data="salesTeamInfo" @close="closeEditModal"/>
    <DealsPopup v-if="addDealDialog"
        :editDialog="addDealDialog"
        :sales-person-id="salesTeamId"
        :deal-id="dealId"
        @closeDeal="closeDeal"
    ></DealsPopup>
    <confirm-model
        v-bind="confirmModel"
        @confirm="confirmActions"
        @close="confirmModel.id = null"
    ></confirm-model>
  </v-container>
</template>

<script>
import BackButton from "@/components/Buttons/BackButton.vue";
import SMSIcon from "@/assets/images/misc/sms.svg";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import CallIcon from "@/assets/images/misc/call.svg";
import EditBtnIcon from "@/assets/images/misc/more-horizontal-square.svg";
import AddIcon from "@/assets/images/misc/plus-icon.svg";
import SalesTeamDeals from "@/components/SalesTeam/SalesTeamDeals.vue";
import DealsPopup from "@/components/SalesTeam/Deals/DealsPopup.vue";
import SalesTeamPopup from "@/components/SalesTeam/SalesTeamPopup.vue";

export default {
  components: {SalesTeamPopup, DealsPopup, EditBtnIcon, AddIcon, CallIcon, SvgIcon, SMSIcon, BackButton, SalesTeamDeals},
  data() {
    return {
      refreshData:false,
      tab: "details",
      salesTeamId: null,
      image: null,
      salesTeamInfo: {
        deleted_services: [],
      },
      valid: false,
      confirmModel: {
        id: null,
        title: null,
        description: null,
      },
      index: 0,
      params: {venue_service_ids: []},
      packageTypes: [
        {type: "I", name: "Individual"},
        {type: "C", name: "Couple"},
        {type: "G", name: "Group"},
      ],
      levels: [],
      pieReload: true,
      showCalender: false,
      addSalesTeamDialog: false,
      addDealDialog: false,
      dealId: null,
      deal:{
        id:null,
        client_name:null,
        contract_start_date:null,
        contract_end_date:null,
        payment_gateway:null,
        agreement_file:null,
        trade_license:null,
        tax_certificate:null,
        contact_person_name:null,
        contact_person_email:null,
        contact_person_mobile:null,
        value_of_deal:null,
        total_installments:null,
      }
    };
  },
  mounted() {
    if (typeof this.$route.params.id != "undefined") {
      this.salesTeamId = parseInt(atob(this.$route.params.id));
      this.salesTeamDetails(this.salesTeamId);
    }
  },
  methods: {
    closeEditModal() {
      this.addSalesTeamDialog = false;
      this.salesTeamDetails(this.salesTeamId);
    },
    addDeal(data=null){
      this.addDealDialog = true;
      this.dealId = data?.id;
    },
    closeDeal(){
      this.addDealDialog = false;
      this.salesTeamDetails(this.salesTeamId);
    },
    gotoSalesTeam() {
      this.$router.push({name: "SalesTeam",});
    },
    cancelSalesTeam() {
      this.addSalesTeamDialog = false;
      this.salesTeamDetails(this.salesTeamId);
    },

    salesTeamDetails(id) {
      if (!id) return;
      this.$http
          .get(`sales-team/view/${id}`)
          .then((response) => {
            if (response.status == 200 && response.data.status == true) {
              this.salesTeamInfo = {};
              const data = response.data.data;
              if (data) {
                this.salesTeamInfo = data;
                // this.salesTeamInfo.status_id = parseInt(data.status_id);
                // this.salesTeamInfo.status_id = data.status_id.toString();
                this.salesTeamInfo.profile_image = data.profile_image ? data.profile_image : null;
                this.salesTeamInfo.total_deals = data.deals.length;
                this.salesTeamInfo.total_sales = data.deals.reduce((sum, deal) => sum + deal.value_of_deal, 0);
                this.salesTeamInfo.total_revenue = data.revenue;
                this.salesTeamInfo.total_commission = data.deals.reduce((sum, deal) => sum + deal.commission_amount, 0);
                this.editFlag = true;
                this.refreshData = !this.refreshData
              }
            }
          })
          .catch((error) => {
            this.errorChecker(error);
            this.gotoSalesTeam();
          });
    },

    editSalesTeam() {
      // this.$http
      //     .get(`sales-team/${this.salesTeamId}`)
      //     .then((response) => {
      //       if (response.status == 200 && response.data.status == true) {
                this.addSalesTeamDialog = true;
          //   }
          // })
          // .catch((error) => {
          //   this.errorChecker(error);
          // });

    },
    confirmDelete(data) {
      this.confirmModel = {
        id: data.id,
        title: `Do you want to ${
            data.status_id == 1 ? "delete" : "reactivate"
        } this sales person?`,
        description:
            "By clicking <b>Yes</b> you can confirm the operation.  Do you need to continue your action ?",
        type: "sales_team",
        data: {
          flag: data.flag ? true : false,
        },
      };
    },

    confirmActions(data) {
      if (data.type == "sales_team") {
        this.toggleSalesTeamStatus(data.id);
      }
      this.confirmModel.id = null;
    },

    toggleSalesTeamStatus(id) {
      this.$http
          .post(`sales-team/status/${id}`)
          .then((response) => {
            if (response.status == 200 && response.data.status == true) {
              this.$router.push({
                name: "SalesTeam",
              });
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
    },
  },
};
</script>

<style scoped>

.flat-table {
  display: block;
  overflow: auto;
  width: auto;
  border-radius: 10px;
}

.flat-table th {
  background-color: rgb(4, 148, 184);
  color: white;
  font-weight: normal;
  padding: 8px 12px;
  text-align: center;
}

.flat-table td {
  background-color: #eeeeee;
  color: #6f6f6f;
  padding: 8px 12px;
}

.stats_data {
  p {
    margin: 0;
    padding: 0;
  }
}
</style>
  